<template>
    <v-container>
        <v-form
            v-model="valid"
            @submit.prevent="doSearch"
        >
            <v-text-field
                v-model="search"
                label="Cari Pertanyaan"
                autofocus
                prepend-icon="mdi-magnify"
                :loading="loading"
                :rules="searchRules"
            ></v-text-field>
        </v-form>

        <div
            v-if="questions && questions.length === 0"
            class="text-center"
        >
            Tidak ada hasil
        </div>

        <v-card
            v-for="question in questions"
            :key="question.id"
            class="mb-2"
        >
            <v-card-text>
                <v-row>
                    <v-col>
                        {{ question.questionBankTitle }}
                    </v-col>
                    <v-col>
                        {{ question.label }}
                    </v-col>
                    <v-col>
                        {{ question.fieldTitle }}
                    </v-col>
                </v-row>

                <p>
                    {{ question.question }}
                </p>

                <ol type="a">
                    <li
                        v-for="(answer, idx) in question.answers"
                        :key="idx"
                    >
                        <span
                            class="white--text green"
                            v-if="answer.correct"
                        >
                            {{ answer.answer }}
                        </span>

                        <span v-else>
                            {{ answer.answer }}
                        </span>
                    </li>
                </ol>

                <div class="mt-2">
                    Ada di:
                    {{
                        question.periods
                            .map((period) => period.title)
                            .join(', ')
                    }}
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    @click="edit(question)"
                    color="primary"
                    text
                >
                    <v-icon left>mdi-pencil</v-icon>
                    edit
                </v-btn>
            </v-card-actions>
        </v-card>

        <edit-question-dialog v-model="editDialog"></edit-question-dialog>
    </v-container>
</template>

<script>
import EditQuestionDialog from '@/components/dashboard/questionbank/EditQuestionDialog'

export default {
    components: {
        EditQuestionDialog,
    },

    data: () => ({
        search: null,
        questions: null,
        loading: false,
        valid: null,
        searchRules: [
            (v) => !!v || 'Pencarian harus diisi',
            (v) => (!!v && v.length > 20) || 'Pencarian minimal 20 karakter',
        ],
        editDialog: false,
    }),

    methods: {
        async doSearch() {
            if (this.valid) {
                this.loading = true
                this.questions = null

                let result = await this.$api.get('questionbank/search', {
                    params: { search: this.search },
                })

                this.questions = result.data.questions
                this.loading = false
            }
        },

        edit(question) {
            this.$store.set('questionbank/selectedQuestionId', question.id)
            this.$route.params.questionbank_id = question.questionBankId
            this.editDialog = true
        },
    },
}
</script>
